import { pctChange } from "./compare/headlineTotals";

const INDUSTRY_CTR = 0.07;

const Hi = ({ children, tone = "lime" }) => (
  <span className={`font-semibold ${tone === "cyan" ? "text-cyan-300" : "text-lime-300"}`}>{children}</span>
);

const trend = (cur, prev, noun) => {
  const p = pctChange(cur, prev);
  if (p == null || Math.abs(p) < 1) return null;
  if (p > 0) return <> That's <Hi>{Math.round(p)}% more {noun}</Hi> than the period before.</>;
  return <> That's a little lighter than the period before, which is normal as budgets and seasons shift.</>;
};

// Builds the auto-written Payoff paragraph as an array of sentences.
export const buildPayoffStory = ({ clientName, rangeText, t, prev, fmt }) => {
  const ctr = t.impressions > 0 ? (t.clicks / t.impressions) * 100 : 0;
  const ctrMultiple = ctr / INDUSTRY_CTR;
  const visitsUp = (pctChange(t.visits, prev?.visits) ?? 0) > 0;
  const working = visitsUp || ctrMultiple >= 1.5;
  const nameShare = t.visits > 0 ? Math.round(((t.direct + t.organic) / t.visits) * 100) : 0;

  const s = [];
  s.push(working
    ? <>Yes, advertising is working for {clientName}. </>
    : <>{clientName}'s advertising is building real momentum. </>);
  if (t.impressions > 0) {
    s.push(<>In {rangeText}, your brand showed up <Hi>{fmt(t.impressions)} times</Hi> across {t.channels} channel{t.channels === 1 ? "" : "s"}
      {t.reach > 0 && <>, reaching about <Hi tone="cyan">{fmt(t.reach)} people</Hi> on Facebook and Instagram alone</>}.
      {trend(t.impressions, prev?.impressions, "exposure")} </>);
  }
  if (t.clicks > 0) {
    s.push(<>People didn't just scroll past: <Hi tone="cyan">{fmt(t.clicks)}</Hi> tapped an ad to learn more
      {ctrMultiple >= 1.5 ? <>, a click rate <Hi>{ctrMultiple >= 10 ? Math.round(ctrMultiple) : ctrMultiple.toFixed(1)}x the industry average</Hi></> : null}. </>);
  }
  if (t.visits > 0) {
    const p = pctChange(t.visits, prev?.visits);
    s.push(<>Your website welcomed <Hi tone="cyan">{fmt(t.visits)} visits</Hi>
      {p != null && p >= 1 ? <>, <Hi>up {Math.round(p)}%</Hi> from the period before</> : null}. </>);
  }
  if (nameShare >= 20) {
    s.push(<>Best of all, <Hi>{nameShare}% of those visits</Hi> came from people who typed your name or found you on Google, a sign {clientName} is becoming the name people remember. </>);
  }
  s.push(<>That's what brand building looks like: showing up, getting noticed, and staying top of mind.</>);
  return s;
};
